/*
 * @Author: alownilow alownilow@163.com
 * @Date: 2023-08-29 14:26:30
 * @LastEditors: alownilow alownilow@163.com
 * @LastEditTime: 2023-08-31 21:15:06
 * @FilePath: \alownilow-web\src\router\index.ts
 * @Description: 
 * alownilow@163.com
 * 
 */
import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeIndex from "@/views/home/Index.vue";
import UserIndex from "@/views/user/Index.vue";
import HContent from '@/views/home/HContent.vue'
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeIndex,
    children: [{
      path: "/",
      component: HContent
    }, {
      path: "index2",
      component: UserIndex
    }]
  },
  {
    path: "/user",
    name: "user",
    component: UserIndex
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
